import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C18.9956 15.8642 15.8642 18.9956 12 19ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Radio"
);
